import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">{contactData.title}</h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-10 max-w-2xl mx-auto">
            {contactData.description}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6 mb-8">
            <a href={`#contact`} className="flex items-center gap-3 px-6 py-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all w-full sm:w-auto justify-center whitespace-nowrap">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-primary-600 text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">邮箱爆料</div>
                <div className="text-sm font-semibold text-foreground-900">{contactData.email}</div>
              </div>
            </a>
            <a href={`#contact`} className="flex items-center gap-3 px-6 py-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-300 transition-all w-full sm:w-auto justify-center whitespace-nowrap">
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-wechat-line text-accent-600 text-lg"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500">微信联系</div>
                <div className="text-sm font-semibold text-foreground-900">{contactData.wechat}</div>
              </div>
            </a>
          </div>

          <div className="inline-flex items-start gap-2 p-4 rounded-lg bg-accent-50 border border-accent-200/60 max-w-lg">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-accent-600 text-sm"></i>
            </div>
            <p className="text-xs text-foreground-600 text-left leading-relaxed">{contactData.tips}</p>
          </div>
        </div>
      </div>
    </section>
  );
}